import { motion } from "framer-motion";
import { Info, MailOpen, MessageSquareWarning, Handshake } from "lucide-react";
import { Editable } from "@/components/builder/Editable";

const AREAS = [
  { icon: MailOpen, key: "comunicazione", title: "Comunicazione", desc: "Email, PEC e WhatsApp in un unico posto: l'AI legge, riassume, classifica e prepara le risposte." },
  { icon: MessageSquareWarning, key: "segnalazioni", title: "Segnalazioni", desc: "Le richieste dei condomini diventano pratiche e ticket tracciati, con priorita e stato sempre chiari." },
  { icon: Handshake, key: "rapporti", title: "Rapporti fornitori & condomini", desc: "Coordina preventivi, interventi e aggiornamenti tra fornitori e condomini, senza far perdere nulla." },
];

export const ScopeClarity = () => {
  return (
    <section id="ambito" data-testid="scope-clarity" className="section-lavender">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="rounded-3xl border border-primary/15 bg-primary/[0.04] p-5 sm:p-6">
          <p className="flex items-start gap-3 text-sm leading-6 text-foreground sm:text-base">
            <span className="mt-0.5 inline-flex h-6 w-6 flex-none items-center justify-center rounded-full bg-primary/10 text-primary"><Info className="h-4 w-4" strokeWidth={2} /></span>
            <Editable path="scope.note">Importante: Sedio non gestisce il condominio al posto tuo e non sostituisce la tua amministrazione. Si concentra su cio che ti fa perdere piu tempo ogni giorno: comunicazione, segnalazioni e rapporti con fornitori e condomini.</Editable>
          </p>
        </div>
        <div className="mt-8 grid gap-5 md:grid-cols-3">
          {AREAS.map((a, i) => (
            <motion.div key={a.key} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.35, delay: i * 0.08 }} className="card-soft card-soft-hover p-7">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary"><a.icon className="h-6 w-6" strokeWidth={2} /></span>
              <h3 className="mt-4 text-lg font-bold text-foreground"><Editable path={`scope.${a.key}.title`}>{a.title}</Editable></h3>
              <p className="mt-1.5 text-sm leading-6 text-muted-foreground"><Editable path={`scope.${a.key}.desc`}>{a.desc}</Editable></p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
